import { createStore, combineReducers } from "redux";
import { reducer as reduxFormReducer } from "redux-form";
import pdfDataSlice from "../reducer/pdfDataSlice";
const reducer = combineReducers({
  form: reduxFormReducer, // mounted under "form"
  pdfDoc: pdfDataSlice,
});

const store = createStore(reducer);

//+  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()

export default store;
